// Shrink large phone photos in the browser before upload so they stay well
// under server/proxy body limits. Falls back to the original file when the
// browser can't decode it (e.g. HEIC on non-Safari) — the server converts those.
const MAX_EDGE = 2560;
const SKIP_BELOW = 1.5 * 1024 * 1024;

const decode = async (file) => {
  if (typeof createImageBitmap === "function") {
    try { return await createImageBitmap(file, { imageOrientation: "from-image" }); } catch { /* fall through */ }
  }
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    return img;
  } finally {
    URL.revokeObjectURL(url);
  }
};

export async function compressImage(file) {
  if (!file?.type?.startsWith("image/") || file.type === "image/gif" || file.size < SKIP_BELOW) return file;
  try {
    const img = await decode(file);
    const w = img.width, h = img.height;
    const scale = Math.min(1, MAX_EDGE / Math.max(w, h));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(w * scale);
    canvas.height = Math.round(h * scale);
    canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.88));
    if (!blob || blob.size >= file.size) return file;
    const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } catch {
    return file;
  }
}
